import { toLower } from "lodash"
import { Link } from "react-router-dom"
import { ActionButton, Button, ReportButton } from "../../../components/Button"
import { Badge } from "../../../components/Circle"
import { Flex } from "../../../components/Flex"
import { MarkText } from "../../../components/MarkText"
import { Paragraph } from "../../../components/Text"
import { FormTooltip } from "../../../components/Tooltip"
import { Upload } from "../../../components/Upload"
import { AddContractIcon } from "../../../icons/AddContractIcon"
import { CircleIcon } from "../../../icons/CircleIcon"
import { ContractsIcon } from "../../../icons/ContractsIcon"
import { EditIcon } from "../../../icons/EditIcon"
import { IconButton } from "../../../icons/IconContainer"
import { RemoveIcon } from "../../../icons/RemoveIcon"
import { SettingsIcon } from "../../../icons/SettingsIcon"
import { UnknownIcon } from "../../../icons/UnknownIcon"
import { UntestedIcon } from "../../../icons/UntestedIcon"
import { UploadContractsIcon } from "../../../icons/UploadContractsIcon"
import { VerifiedIcon } from "../../../icons/VerifiedIcon"
import { formatDate, highlightText } from "../../../utils"

export const contracts = ({
    isAdmin,
    contractsWrite,
    orgWrite,
    showForm,
    tab,
    deleteItem,
    editValues,
    contractsMassUpdate,
    contractName,
    pathname,
    search,
    context,
    selected,
    uploadContracts,
    updateContractsDate
}) => {
    let breadcrumbs = [
        { title: "Contracts", href: "/contracts" },
        { title: contractName, href: "/contracts/" + selected }
    ];

    const tabs = {
        contracts: {
            enabled: isAdmin,
            footer: contractsWrite &&
            <Button onClick={() => showForm("contract")}>
                <AddContractIcon size={20} />
                Create Contract
            </Button>,
            columns: [
                {
                    title: <CircleIcon size={16} />,
                    dataIndex: 'inactive',
                    render: (text, record, index) =>
                        <>
                            {text == 1 ?  <UntestedIcon size={16} /> : text == 0 ? <VerifiedIcon size={16} /> : <UnknownIcon size={16} />}
                        </>,
                    width: 56,
                    sorter: (a, b) => { if (a && a.hasOwnProperty("inactive")) return (a.inactive === b.inactive) ? 0 : a.inactive ? -1 : 1 }
                },
                {
                    title: "Contract Name",
                    dataIndex: 'contractName',
                    defaultSortOrder: 'asc',
                    render: (text, record, index) => (
                        <Link to={{ pathname: `${pathname}/${record.contractNumber}`, state: { from: pathname + search }}}>
                            <MarkText title={text} text={highlightText(text, context)} />
                        </Link>
                        ),
                    sorter: (a, b) => { if (a && a.hasOwnProperty("contractName") && a.contractName) return a.contractName.localeCompare(b.contractName) }
                },
                {
                    title: "Description",
                    dataIndex: 'description',
                    render: (text, record, index) => (
                        <MarkText title={text} text={highlightText(text, context)} />
                    ),
                    sorter: (a, b) => { if (a && a.hasOwnProperty("description") && a.description) return a.description.localeCompare(b.description) }
                },
                {
                    title: "Registered by",
                    dataIndex: 'registeredBy',
                    render: (text, record, index) => (
                        <MarkText title={text} text={highlightText(text, context)} />
                    ),
                    sorter: (a, b) => { if (a && a.hasOwnProperty("registeredBy") && a.registeredBy) return a.registeredBy.localeCompare(b.registeredBy) }
                }
            ]
        },
        all: {
            enabled: isAdmin,
            header: <Flex gap={{ right: 16 }}>
                {contractsWrite &&
                    <Link to={{ pathname: `/contracts`, state: { from: null }}}>
                        <FormTooltip visible text="Manage contracts">
                            <ActionButton >
                                <SettingsIcon />
                            </ActionButton>
                        </FormTooltip>
                    </Link>}
                {isAdmin && <ReportButton makeReport={() => showForm("orgs_contracts_report")}/>}
            </Flex>,
            footer: contractsWrite && orgWrite &&
                <>
                    <Upload
                        customRequest={uploadContracts}
                    >
                        <Button>
                            <UploadContractsIcon size={20} />
                            Upload Contracts
                        </Button>
                    </Upload>
                    <Button onClick={() => showForm("contracts")}>
                        <ContractsIcon size={20} />
                        Apply Contract
                    </Button>
                </>,
            columns: [
                {
                    title: <CircleIcon size={16} />,
                    dataIndex: 'expired',
                    width: 50,
                    render: (text, record, index) => (
                        <Badge color={ text < 0 ? "var(--sp-error-color)" : text > 10 ? "var(--sp-success-color)" : "var(--sp-warning-color)" } />
                    ),
                    sorter: (a, b) => { if (a && a.hasOwnProperty("expired")) return a.expired - b.expired}
                },
                            {
                    title: "Contract Name",
                    dataIndex: 'contractName',
                    defaultSortOrder: 'asc',
                    width: 150,
                    render: (text, record, index) => (
                        <Link to={{ pathname: `/contracts/${record.contractNumber}`, state: { from: pathname + search }}}>
                            <MarkText title={text} text={highlightText(text, context)} />
                        </Link>
                    ),
                    sorter: (a, b) => { if (a && a.hasOwnProperty("contractName") && a.contractName) return a.contractName.localeCompare(b.contractName) }
                },
                {
                    title: "Organization",
                    dataIndex: 'orgName',
                    render: (text, record, index) => (
                        <Link to={`/organisations/${record.orgAlias}`}>
                            <MarkText title={text} text={highlightText(text, context)} />
                        </Link>
                    ),
                    sorter: (a, b) => { if (a && a.hasOwnProperty("orgName") && a.orgName) return a.orgName.localeCompare(b.orgName) }
                },
                {
                    title: "Expiration date",
                    dataIndex: "endDate",
                    width: 150,
                    render: (text, record, index) => (
                        <MarkText title={text} text={highlightText(formatDate(text, "DD-MMM-YYYY"), context)} />
                    ),
                    sorter: (a, b) => { if (a && a.hasOwnProperty("endDate") && a.endDate) return a.endDate.localeCompare(b.endDate) },
                },
                {
                    title: "Registered by",
                    dataIndex: 'registeredBy',
                    render: (text, record, index) => (
                        <MarkText title={text} text={highlightText(text, context)} />
                    ),
                    sorter: (a, b) => { if (a && a.hasOwnProperty("registeredBy") && a.registeredBy) return a.registeredBy.localeCompare(b.registeredBy) }
                },
                {
                    title: "Updated by",
                    dataIndex: 'updatedBy',
                    render: (text, record, index) => (
                        <MarkText title={text} text={highlightText(text, context)} />
                    ),
                    sorter: (a, b) => { if (a && a.hasOwnProperty("updatedBy") && a.updatedBy) return a.updatedBy.localeCompare(b.updatedBy) }
                },
                {
                    dataIndex: "edit",
                    width: 50,
                    render: (text, record, index) => (
                        <EditIcon
                            size={20}
                            color="var(--sp-label-color)"
                            hoverColor="var(--sp-paragraph-color)"
                            onClick={() => editValues({ entity: "contracts", values: record })}
                        />
                    )
                },
                {
                    dataIndex: "remove",
                    width: 50,
                    render: (text, record, index) => (
                        <RemoveIcon
                            size={20}
                            color="var(--sp-label-color)"
                            hoverColor="var(--sp-error-color)"
                            onClick={() => deleteItem({ content: <Paragraph>Are you sure you want to delete the <b>{record.contractName}</b> contract for <b>{record.orgName}</b>?</Paragraph>, values: { alias: record.orgAlias, contract: toLower(record.contractName) }})}
                        />
                    )
                }
            ]
        },
        organisations: {
            enabled: isAdmin,
            breadcrumbs: breadcrumbs.concat([
                { title: "Organizations" }
            ]),
            footer: contractsMassUpdate &&
                <Button
                    // disabled={!(Array.isArray(data) && data.length)}
                    onClick={() => updateContractsDate()}
                >
                    Update All
                </Button>,
            columns: [
                {
                    title: <CircleIcon size={16} />,
                    dataIndex: 'expired',
                    width: 50,
                    render: (text, record, index) => (
                        <Badge size={8} color={ text <= 0 ? "var(--sp-error-color)" : text > 10 ? "var(--sp-success-color)" : "var(--sp-warning-color)" } />
                    ),
                    sorter: (a, b) => { if (a && a.hasOwnProperty("expired")) return a.expired - b.expired}
                },
                {
                    title: "Name",
                    dataIndex: 'orgName',
                    defaultSortOrder: 'asc',
                    render: (text, recors, index) => <MarkText title={text} text={highlightText(text, context)} />,
                    sorter: (a, b) => { if (a && a.hasOwnProperty("orgName") && a.orgName) return a.orgName.localeCompare(b.orgName) }
                },
                {
                    title: "Expiration date",
                    dataIndex: "endDate",
                    width: 150,
                    defaultSortOrder: "desc",
                    render: (text, record, index) => text ? formatDate(text, "DD-MMM-YYYY") : "-",
                    sorter: (a, b) => { if (a && a.hasOwnProperty("endDate") && a.endDate) return a.endDate.localeCompare(b.endDate) },
                },
                {
                    title: "Ecokits",
                    dataIndex: "ecokits",
                    width: 70,
                    render: (text, record, index) => text == 1 ? "Yes" : text == 0 ? "No" : "-",
                    sorter: (a, b) => { if (a && a.hasOwnProperty("ecokits") && a.ecokits) return a.ecokits - b.ecokits },
                },
                {
                    title: "Minor Rel",
                    dataIndex: "rToMinorRel",
                    width: 90,
                    render: (text, record, index) => text == 1 ? "Yes" : text == 0 ? "No" : "-",
                    sorter: (a, b) => { if (a && a.hasOwnProperty("rToMinorRel") && a.rToMinorRel) return a.rToMinorRel - b.rToMinorRel },
                },
                {
                    dataIndex: "remove",
                    width: 50,
                    render: (text, record, index) => (
                        <RemoveIcon
                            size={20}
                            color="var(--sp-label-color)"
                            hoverColor="var(--sp-paragraph-color)"
                            onClick={() => deleteItem({ content: <Paragraph>Are you sure you want to delete the <b>{contractName}</b> contract for <b>{record.orgName}</b>?</Paragraph>, values: { alias: record.orgAlias, contract: toLower(contractName) }})}
                        />
                    )
                }
            ]
        },
        packages: {
            enabled: isAdmin,
            breadcrumbs: breadcrumbs.concat([
                { title: "Packages" }
            ]),
            columns: [
                {
                    title: <CircleIcon size={16} />,
                    dataIndex: 'verified',
                    render: (text, record, index) =>
                        <>
                            {text == 1 ? <VerifiedIcon size={16} /> : text == 0 ? <UntestedIcon size={16} /> : <UnknownIcon size={16} />}
                        </>,
                    width: 56,
                    sorter: (a, b) => { if (a && a.hasOwnProperty("verified") && a.verified) return a.verified - b.verified }
                },
                {
                    title: "Package Name",
                    dataIndex: "name",
                    defaultSortOrder: "asc",
                    render: (text, record, index) => (
                        <Link to={{pathname: `/packages/${record.packageNumber}`, state: { from: pathname + search }}}>
                            <MarkText style={{ fontWeight: 600 }} text={highlightText(text, context)} />
                        </Link>
                    ),
                    sorter: (a, b) => { if (a && a.hasOwnProperty("name") && a.name) return a.name.localeCompare(b.name) }
                },
                {
                    title: "Version",
                    dataIndex: "version",
                    width: 200,
                    render: (text, record, index) => (
                        <MarkText text={highlightText(text, context)} />
                    ),
                    sorter: (a, b) => { if (a && a.hasOwnProperty("version") && a.version) return a.version.localeCompare(b.version) }
                }
            ]
        }
    };

    if (Object.keys(tabs).includes(tab)) {
        return tabs[tab];
    }

    return null;
}